import axios from 'axios';
import CommonConstants from '../utils/CommonConstants';
const apiUrl = CommonConstants.Actions.api;

export function getShipment(token,page,per_page,status,range){
	return function(dispatch){
	dispatch({type: 'GET_SHIPMENT_FETCHING',});
	axios.get(apiUrl+'shipments?page='+page+'&per_page='+per_page+'&status='+status+'&range='+range+'&exclude_children=true',{
	"page" : page,
	"per_page" : per_page,
	"status" : status,
	"range" : range,
	token,	
	}).then((response) => {
	dispatch({type: 'GET_SHIPMENT_FULFILLED', payload: response.data,});
	}).catch((err) =>{
	dispatch({type: 'GET_SHIPMENT_REJECTED', payload: err,})
	})
	}
}
export function getOrderDetails(id,token){
	return function(dispatch){
	axios.get(apiUrl+'shipments/'+id,
	token
	).then((response) => {
	dispatch({type: 'GET_ORDER_FULFILLED', payload: response.data,})
	}).catch((err) =>{
	dispatch({type: 'GET_ORDER_REJECTED', payload: err,})
	})
	}
}
export function getTrackDetails(tracking_number){
	return function(dispatch){
  dispatch({type: 'GET_TRACK_FETCHING'})
	axios.get(apiUrl+'track/'+tracking_number
	).then((response) => {
		dispatch({type: 'GET_TRACK_FULFILLED', payload: response.data,})
	}).catch((err) =>{
		dispatch({type: 'GET_TRACK_REJECTED', payload: err,})
	})
	}
}
export function removeTrackDetails () {
  return function (dispatch) {
    dispatch({ type: 'REMOVE_TRACK_DETAILS' })
  }
}
export function resetOrders(){
	return function(dispatch){
	dispatch({type: 'RESET_ORDERS',});
	}

}




/** WEBPACK FOOTER **
 ** ./src/actions/ShipmentAction.js
 **/